import { Button, Form, Table } from "react-bootstrap";
import { useState } from "react";
import { saveAs } from "file-saver";

function CinPlcChecker() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [file, setFile] = useState("");
  const [statusMsg, setStatusMsg] = useState("");
  const [results, setResults] = useState([]);
  const [summary, setSummary] = useState(null);

  const submitFile = async () => {
    setStatusMsg("");
    setResults([]);
    setSummary(null);

    if (!file) {
      setStatusMsg("Upload an Excel file with CINs!");
      return;
    }

    setStatusMsg("Processing...");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(
        apiServer + "api/cin_plc_checker/upload_file/",
        { method: "POST", body: formData }
      );
      const data = await response.json();

      if (data.detail) {
        setStatusMsg(data.detail);
      } else {
        setResults(data.results || []);
        setSummary(data.summary || null);
        setStatusMsg("");
      }
    } catch (e) {
      console.log(e);
      setStatusMsg("An error occurred while processing the file.");
    }
  };

  const escapeCsv = (val) => {
    const str = String(val ?? "");
    return str.includes(",") || str.includes('"') ? `"${str.replace(/"/g, '""')}"` : str;
  };

  const exportToExcel = () => {
    const header = ["#", "CIN", "Class", "Company Name", "Date Of Registration", "Company Type", "Activity Code"];
    const csvRows = [header.join(",")];
    results.forEach((row, idx) => {
      csvRows.push([
        idx + 1,
        escapeCsv(row.cin),
        escapeCsv(row["class"]),
        escapeCsv(row.company_name),
        escapeCsv(row.date_of_registration),
        escapeCsv(row.company_type),
        escapeCsv(row.activity_code),
      ].join(","));
    });
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "cin_plc_checker_results.csv");
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Form.Control
        type="file"
        accept=".xlsx"
        onChange={(e) => setFile(e.target.files[0])}
      />
      <Button
        variant="primary"
        type="button"
        style={{ marginTop: "15px" }}
        onClick={submitFile}
      >
        Submit
      </Button>

      {statusMsg && (
        <p style={{ marginTop: "10px", color: statusMsg.includes("error") || statusMsg.includes("Upload") ? "red" : "inherit" }}>
          {statusMsg}
        </p>
      )}

      {summary && (
        <div style={{ marginTop: "15px", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "5px" }}>
          <strong>Summary:</strong> Total: {summary.total} | Private to Public: {summary.private_to_public} | Private: {summary.private} | Public: {summary.public} | Other: {summary.other}
        </div>
      )}

      {results.length > 0 && (
        <>
        <Button
          variant="success"
          type="button"
          style={{ marginTop: "15px" }}
          onClick={exportToExcel}
        >
          Export to CSV
        </Button>
        <Table striped bordered hover style={{ marginTop: "15px" }}>
          <thead>
            <tr>
              <th>#</th>
              <th>CIN</th>
              <th>Company Name</th>
            </tr>
          </thead>
          <tbody>
            {results.map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: "#fff3cd" }}>
                <td>{idx + 1}</td>
                <td>{row.cin}</td>
                <td>{row.company_name}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        </>
      )}
    </div>
  );
}

export default CinPlcChecker;
